import { createContext, useContext, useMemo, useState } from "react";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {

    const [auth, setAuth] = useState(() => {

        const stored = localStorage.getItem("auth");

        return stored
            ? JSON.parse(stored)
            : {
                accessToken: null,
                refreshToken: null,
                user: null
            };

    });

    /**
     * Login
     */
    const login = (response) => {
        console.log("Logging in with response:", response);
        const authData = {

            accessToken: response.accessToken,

            refreshToken: response.refreshToken,

            user: response.user,

            role: response.role ?? response.user?.role,

            accessMask: response.accessMask ?? response.user?.accessMask


        };
        console.log("Storing auth data:", authData);
        localStorage.setItem(

            "auth",

            JSON.stringify(authData)

        );

        setAuth(authData);

    };

    /**
     * Logout
     */
    const logout = () => {

        localStorage.removeItem("auth");

        setAuth({

            accessToken: null,

            refreshToken: null,

            user: null

        });

    };

    /**
     * Update User
     */
    const updateUser = (user) => {

        const updated = {

            ...auth,

            user

        };

        localStorage.setItem(

            "auth",

            JSON.stringify(updated)

        );

        setAuth(updated);

    };

    /**
     * Update Access Mask
     */
    const updateAccessMask = (mask) => {

        const updated = {

            ...auth,

            user: {

                ...auth.user,

                accessMask: mask

            }

        };

        localStorage.setItem(

            "auth",

            JSON.stringify(updated)

        );

        setAuth(updated);

    };

    const value = useMemo(() => ({

        ...auth,

        login,

        logout,

        updateUser,

        updateAccessMask,

        isAuthenticated: !!auth.accessToken

    }), [auth]);

    return (

        <AuthContext.Provider value={value}>

            {children}

        </AuthContext.Provider>

    );

}

export function useAuth() {

    const context = useContext(AuthContext);

    if (!context) {

        throw new Error(

            "useAuth must be used inside AuthProvider"

        );

    }

    return context;

}